<template>
    <div class="p-admin-conf-consultation">
        <div class="card mb-3">
            <div class="card-header">所属コード設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <template v-if="conf.category === confCategory.user">
                        <div v-if="conf.value_type === confValue.bool" class="m-1">
                            <div class="form-group m-form__group">
                                <label
                                    v-if="conf.is_display_name"
                                    :for="`key-${conf.key}`"
                                    class="vc-conf-name">
                                    {{ conf.name }}：
                                </label>
                                <div>
                                    <div class="form-check mb-1">
                                        <input
                                            v-model="configurations[index].value"
                                            value="1"
                                            :id="`key-${conf.key}_1`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="radio">
                                        <label
                                            :for="`key-${conf.key}_1`"
                                            style="cursor:pointer;"
                                            class="form-check-label">
                                            {{ conf.label_bool_1 }}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input
                                            v-model="configurations[index].value"
                                            value="0"
                                            :id="`key-${conf.key}_2`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="radio">
                                        <label
                                            :for="`key-${conf.key}_2`"
                                            style="cursor:pointer;"
                                            class="form-check-label">
                                            {{ conf.label_bool_2 }}
                                        </label>
                                    </div>
                                </div>
                                <div
                                    v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                                </div>
                            </div>
                        </div>
                        <div v-else-if="conf.key === keyUserCode && flgUserCode" class="m-1">
                            <div class="form-group m-form__group">
                                <label class="small" for="format_first">{{ conf.name }}：</label>
                                <div class="d-flex align-items-center">
                                    <select
                                        v-model="format.first"
                                        name="medical_course_id"
                                        id="format_first"
                                        class="form-control custom-select"
                                        :class="{ 'is-invalid' : errors.format }"
                                        style="max-width: 200px;">
                                        <option :value="null">半角英語の桁数</option>
                                        <option v-for="n in 11" :value="n - 1">{{ n - 1 }}</option>
                                    </select>
                                    &nbsp;&nbsp;
                                    <select
                                        v-model="format.last"
                                        name="medical_course_id"
                                        id="format_last"
                                        class="form-control custom-select"
                                        :class="{ 'is-invalid' : errors.format }"
                                        style="max-width: 200px;">
                                        <option :value="null">半角数字の桁数</option>
                                        <option v-for="n in 11" :value="n - 1">{{ n - 1 }}</option>
                                    </select>
                                </div>
                                <div
                                    v-if="formatExample !== ''"
                                    class="text-muted small mt-2">
                                    {{ `（設定サンプル：${formatExample}）` }}
                                </div>
                                <div
                                    v-if="errors.format"
                                    class="invalid-feedback d-block mt-2">
                                    {{ errors.format[0] }}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from "../../../YokumiruHelper"

export default {
    props: {
        conf: {
            type: Array,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            keyFlgUserCode: 'flg_user_code',
            keyUserCode: 'user_code',
            configurations: [],
            format: {
                first: null,
                last: null,
            },
            errors: {},
            inProgress: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            let configurations = this.helper.bindConfigurationsValue(this.configurations)

            // 所属コードの設定値をバインド
            configurations = configurations.map(conf => {
                if (conf.key === this.keyUserCode) {
                    conf.value_str = this.formatRegex
                    return this.flgUserCode ? conf : null
                }
                return conf
            })
            return configurations.filter(conf => conf !== null)
        },

        /**
         * 所属コードのフォーマット設定フラグ
         */
        flgUserCode: function () {
            const confFlgUserCode = this.configurations.find(conf => conf.key === this.keyFlgUserCode)
            return confFlgUserCode && confFlgUserCode.value == 1
        },

        /**
         * フォーマットサンプルを返却
         *
         * @return {string}
         */
        formatExample: function () {
            let result = ''
            if (this.format.first > 0) {
                result += 'ABCDEFGHIJ'.slice(0, this.format.first)
            }
            if (this.format.last > 0) {
                result += '0123456789'.slice(0, this.format.last)
            }
            return result
        },

        /**
         * フォーマット正規表現を返却
         *
         * @return {string}
         */
        formatRegex: function () {
            if (this.formatExample === '') return ''
            return `[a-zA-Z]{${this.format.first || 0}}[0-9]{${this.format.last || 0}}`
        },
    },

    methods: {
        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.flgUserCode && this.formatRegex === '') {
                this.errors = { format: ['フォーマットの桁数を選択してください。'] }
                bus.$emit('alert-danger')
                return
            }

            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.configurations.endpoint.base
            const configurations = this.preparedConfigurations

            await axios.post(endpoint, configurations)
                .then(() => {
                    this.errors = {}
                    bus.$emit('alert-success', '設定を更新しました。')
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },
    },

    watch: {
        conf: function (conf) {
            this.configurations = conf

            // 所属コードの初期値をバインド
            this.configurations.forEach(conf => {
                if (conf.key === this.keyUserCode && conf.value) {
                    const result = conf.value.match(/{[0-9]}/g).map(val => Number(val.substr(1, 1)))
                    this.format.first = result[0]
                    this.format.last = result[1]
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.vc-conf-name {
    color: #5f5f5f;
    font-size: 13px;
    font-weight: bold;
}

.vc-input-int {
    max-width: 100px;
}
</style>
